module.exports = __webpack_public_path__ + "static/media/main-classes-img2.58d3343f.svg";